{
  "pt": {
    "notification": {
      "actions": {
        "delete": "Eliminar a notificação",
        "deleteAll": "Eliminar tudo",
        "markAllAsRead": "Marcar tudo como lido",
        "mark_as_read": "Marcar como lido",
        "mark_as_unread": "Marcar como não lido"
      },
      "customers": {
        "announcement": {
          "create": "criou uma publicação de notícias. | criou {group_notification_count} postagens de notícias. |_| criou {group_notification_count} postagens de notícias."
        },
        "decision": {
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>."
          },
          "published": {
            "customer": "decisão adicionada <i>'{notifiable_name}'</i>."
          },
          "relaunched": "tornou a decisão <i>'{notifiable_name}'</i> novamente disponível."
        },
        "decision_document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | carregou documentos {group_notification_count} na decisão <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in decision <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "proposta aprovada <i>\"{notifiable_name}'</i> na decisão <i>\"{group_name}'</i>. | aprovadas {group_notification_count} propostas na decisão <i>'{group_name}'</i>. | aprovadas {group_notification_count} propostas na decisão <i>'{group_name}'</i>.",
          "create": "proposta criada <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | criou {group_notification_count} propostas na decisão <i>'{group_name}'</i>. | criou {group_notification_count} propostas na decisão <i>'{group_name}'</i>.",
          "edit_approved": "editou a proposta aprovada <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | editado {group_notification_count} propostas aprovadas na decisão <i>'{group_name}'</i>. | editado {group_notification_count} propostas aprovadas na decisão <i>'{group_name}'</i>.",
          "relaunched": "fez a proposta <i>\"{notifiable_name}'</i> que solicitou alterações para disponível novamente | fez {group_notification_count} propostas na decisão <i>\"{group_name}'</i> que solicitou alterações para disponível novamente | fez {group_notification_count} propostas na decisão <i>\"{group_name}'</i> que solicitou alterações para disponível novamente"
        },
        "document": {
          "create": "documento carregado <i>'{notifiable_name}'</i>. | documentos carregados em {group_notification_count}. |_| carregado {group_notification_count} documentos.",
          "installment": {
            "create": "adicionada uma fatura <i>'{notifiable_name}'</i> a uma prestação. | adicionou {group_notification_count} facturas a uma prestação. |_| adicionou as facturas {group_notification_count} a uma prestação."
          },
          "invoice": {
            "create": "fatura carregada <i>'{notifiable_name}'</i>. | carregado {group_notification_count} facturas. |_| carregado {group_notification_count} facturas."
          },
          "proposal": {
            "create": "adicionado o documento <i>'{notifiable_name}'</i> à proposta <i>'{group_name}'</i>. | adicionou documentos {group_notification_count} à proposta <i>'{group_name}'</i>. |_| adicionados documentos {group_notification_count} à proposta <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "Os seus dados de exportação estão prontos para serem descarregados."
        },
        "installment": {
          "published": "disponibilizou a prestação <i>'{notifiable_name}'</i>.  | tornou {group_notification_count} parcelas disponíveis. | disponibilizou as parcelas do {group_notification_count}.",
          "status": {
            "changed": "alterou o status da parcela <i>'{notifiable_name}'</i> para <i>'{status}'</i>.  | mudou o status das parcelas de {group_notification_count}. | alterou o status das parcelas de {group_notification_count}."
          }
        },
        "issue": {
          "approval": {
            "create": "aprovou um obstáculo <i>'{notifiable_name}'</i> | aprovou {group_notification_count} obstáculos. |_| aprovaram {group_notification_count} obstáculos."
          },
          "create": "criou um obstáculo <i>'{notifiable_name}'</i> | criou {group_notification_count} obstáculo para <i>'{group_name}'</i> |_| criou {group_notification_count} obstáculo para <i>'{group_name}'</i>",
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>."
          },
          "status": {
            "update": "actualizou o estado de <i>'{notifiable_name}'</i> para <i>'{status}'</i> | actualizou o estado de {group_notification_count} snags. |_| actualizou o estado de {group_notification_count} snags."
          }
        },
        "question": {
          "create": "criou a pergunta <i>'{notifiable_name}'</i> em FAQ <i>'{group_name}'</i>. | criou {group_notification_count} perguntas em FAQ <i>'{group_name}'</i>. |_| criou {group_notification_count} perguntas em FAQ <i>'{group_name}'</i>."
        },
        "reminder": {
          "decision": {
            "due": "Não se esqueça de tomar uma decisão para <i>'{notifiable_name}'</i>."
          },
          "installment": {
            "due": "Não se esqueça de efetuar um pagamento para <i>'{notifiable_name}'</i>."
          }
        },
        "survey": {
          "published": "gostaria de receber a sua opinião sobre <i>'{group_name}'</i>."
        },
        "ticket": {
          "create": "iniciou a conversa <i>'{notifiable_name}'</i>.",
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>.",
            "move": "moveu a sua mensagem para a conversação <i>'{group_name}'</i>"
          }
        },
        "ticket_document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> em conversação <i>'{group_name}'</i>. | carregou documentos {group_notification_count} em conversa <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in conversation <i>'{group_name}'</i>."
        }
      },
      "employees": {
        "announcement": {
          "create": "criou um post de notícias. | criou {group_notification_count} postagens de notícias em <i>'{group_name}'</i>. |_| criou {group_notification_count} postagens de notícias em <i>'{group_name}'</i>."
        },
        "decision": {
          "mention": {
            "create": "mencionou-o numa conversa <i>'{group_name}'</i>. | mencionou-o em {group_notification_count} mensagens na conversa <i>'{group_name}'</i>. |_| mencionou-o em {group_notification_count} mensagens na conversa <i>'{group_name}'</i>."
          },
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>."
          },
          "not_interested": "não está interessado na decisão <i>'{notifiable_name}'</i>.",
          "responsible": {
            "update": "tornou-o o novo responsável pela decisão <i>'{notifiable_name}'</i>"
          }
        },
        "decision_document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | carregou documentos {group_notification_count} na decisão <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in decision <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "proposta aprovada <i>\"{notifiable_name}'</i> na decisão <i>\"{group_name}'</i>. | propostas aprovadas {group_notification_count} na decisão <i>'{group_name}'</i>. |_| aprovadas {group_notification_count} propostas na decisão <i>'{group_name}'</i>.",
          "create": "proposta criada <i>\"{notifiable_name}'</i> na decisão <i>\"{group_name}'</i>. | criou propostas {group_notification_count} na decisão <i>'{group_name}'</i>. |_| criado {group_notification_count} propostas na decisão <i>'{group_name}'</i>.",
          "requested_changes": "solicita alterações para a proposta <i>\"{notifiable_name}'</i> na decisão <i>\"{group_name}'</i>. | solicita alterações para as propostas {group_notification_count} na decisão <i>'{group_name}'</i>. |_| solicita alterações para as propostas {group_notification_count} na decisão <i>'{group_name}'</i>."
        },
        "document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> no diretório <i>'{group_name}'</i>. | carregou documentos {group_notification_count} no diretório <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in directory <i>'{group_name}'</i>.",
          "proposal": {
            "create": "adicionado o documento <i>'{notifiable_name}'</i> à proposta <i>'{group_name}'</i>. | adicionou documentos {group_notification_count} à proposta <i>'{group_name}'</i>. |_| adicionados documentos {group_notification_count} à proposta <i>'{group_name}'</i>."
          }
        },
        "email_conversation": {
          "client": {
            "create": "recebeu um correio eletrónico de entrada <i>'{notifiable_name}'</i>. | recebeu {group_notification_count} emails de entrada. |_| recebeu {group_notification_count} emails de entrada."
          },
          "project": {
            "create": "recebeu um correio eletrónico de entrada <i>'{notifiable_name}'</i>. | recebeu {group_notification_count} emails de entrada. |_| recebeu {group_notification_count} emails de entrada."
          }
        },
        "export": {
          "create": "Os seus dados de exportação estão prontos para serem descarregados."
        },
        "issue": {
          "approved": "aprovado snag <i>'{notifiable_name}'</i> para a unidade <i>'{level_name}'</i>. | approved {group_notification_count} snags'</i>. |_| approved {group_notification_count} snags.",
          "create": "criou um novo obstáculo para a unidade <i>{level_name}</i> | criou {group_notification_count} novos obstáculos para <i>{level_name}</i> |_| criou {group_notification_count} novos obstáculos para <i>{level_name}</i>",
          "mention": {
            "create": "mencionou-o numa conversa <i>'{group_name}'</i>. | mencionou-o em {group_notification_count} mensagens na conversa <i>'{group_name}'</i>. |_| mencionou-o em {group_notification_count} mensagens na conversa <i>'{group_name}'</i>."
          },
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>."
          },
          "rejected": "rejeitou o obstáculo <i>'{notifiable_name}'</i> para a unidade <i>'{level_name}'</i>. | rejeitado {group_notification_count} snags'</i>. |_| rejeitado {group_notification_count} snags."
        },
        "question": {
          "create": "criou a pergunta <i>'{notifiable_name}'</i> em FAQ <i>'{group_name}'</i>. | criou {group_notification_count} perguntas em FAQ <i>'{group_name}'</i>. |_| criou {group_notification_count} perguntas em FAQ <i>'{group_name}'</i>."
        },
        "survey_answer": {
          "create": "respondeu <i>'{group_name}'</i>."
        },
        "ticket": {
          "create": "iniciou a conversa <i>'{notifiable_name}'</i>.",
          "mention": {
            "create": "mencionou-o numa conversa <i>'{group_name}'</i>. | mencionou-o em {group_notification_count} mensagens na conversa <i>'{group_name}'</i>. |_| mencionou-o em {group_notification_count} mensagens na conversa <i>'{group_name}'</i>."
          },
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>."
          },
          "responsible": {
            "bulk_update": "transferiu a responsabilidade de várias conversas no projeto <i>'{project_name}'</i> de <i>'{responsible_old_name}'</i> para você.",
            "update": "conversa atribuída <i>'{notifiable_name}'</i> a si."
          }
        },
        "ticket_document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> em conversação <i>'{group_name}'</i>. | carregou documentos {group_notification_count} em conversa <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in conversation <i>'{group_name}'</i>."
        },
        "todo": {
          "assign": "atribuiu-lhe a tarefa <i>'{notifiable_name}'</i> na lista <i>'{group_name}'</i>. | atribuiu {group_notification_count} tarefas a si na lista <i>'{group_name}'</i>. | atribuiu a tarefa <i>'{notifiable_name}'</i> a si na lista <i>'{group_name}'</i>. | atribuiu {group_notification_count} tarefas a si na lista <i>'{group_name}'</i>."
        }
      },
      "labels": {
        "all": "Todos os projectos",
        "allDecisions": "Todas as decisões",
        "allStatuses": "Todos",
        "filter": "Filtro",
        "hideDecisionFilter": "Ocultar filtro de decisão",
        "hideExtraFilters": "Ocultar filtros extra",
        "noNewNotification": "Já está tudo em dia!",
        "noResults": "Sem resultados. Tenta outra coisa!",
        "none": "Atualmente, não tem quaisquer notificações.",
        "notification_level_name_asc": "Unidade A->Z",
        "notification_level_name_desc": "Unidade Z->A",
        "pinSidebar": "Pino da barra lateral",
        "showDecisionFilter": "Mostrar filtro de decisão",
        "showExtraFilters": "Mostrar filtros extra",
        "sort": "Ordenar por",
        "status": "Estado",
        "unpinSidebar": "Desafixar a barra lateral",
        "unreadOnly": "Apenas não lidos",
        "updated_at_asc": "O mais velho primeiro",
        "updated_at_desc": "Mais recente primeiro"
      },
      "other_user": "e 1 outro",
      "other_users": "e 1 outro | e {count} outros",
      "partners": {
        "decision": {
          "message": {
            "create": "enviou uma nova mensagem na conversa <i>'{group_name}'</i>. | enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>. |_| enviou {group_notification_count} novas mensagens na conversa <i>'{group_name}'</i>."
          },
          "not_interested": "não está interessado na decisão <i>'{notifiable_name}'</i>.",
          "published": {
            "partners": "decisão iniciada <i>'{notifiable_name}'</i>. | started {group_notification_count} <i>'{group_name}'</i> decisões. |_| started {group_notification_count} <i>'{group_name}'</i> decisions."
          }
        },
        "decision_document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | carregou documentos {group_notification_count} na decisão <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in decision <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "proposta aprovada <i>\"{notifiable_name}'</i> na decisão <i>\"{group_name}'</i>. | aprovou a proposta <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | aprovou uma proposta na decisão <i>'{group_name}'</i>. | aprovou propostas na decisão <i>'{group_name}'</i>.",
          "create": "proposta criada <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>. | criou propostas {group_notification_count} na decisão <i>'{group_name}'</i>. |_| criado {group_notification_count} propostas na decisão <i>'{group_name}'</i>.",
          "requested_changes": "solicita alterações para a proposta <i>\"{notifiable_name}'</i> na decisão <i>\"{group_name}'</i>. | solicita alterações para as propostas {group_notification_count} na decisão <i>'{group_name}'</i>. |_| solicita alterações para as propostas {group_notification_count} na decisão <i>'{group_name}'</i>."
        },
        "document": {
          "proposal": {
            "create": "adicionado o documento <i>'{notifiable_name}'</i> à proposta <i>'{group_name}'</i>. | adicionou documentos {group_notification_count} à proposta <i>'{group_name}'</i>. |_| adicionados documentos {group_notification_count} à proposta <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "Os seus dados de exportação estão prontos para serem descarregados."
        },
        "issue": {
          "status": {
            "update": "actualizou o estado de um obstáculo em <i>'{group_name}'</i>. | atualizou o status de {group_notification_count} obstáculos em <i>'{group_name}'</i>. |_| actualizou o estado de {group_notification_count} obstáculos em <i>'{group_name}'</i>."
          }
        },
        "issue_list": {
          "published": "publicou uma lista de problemas <i>'{notifiable_name}'</i> | publicou a lista de problemas <i>'{notifiable_name}'</i> para {group_notification_count} unidades |_| publicou a lista de problemas <i>'{notifiable_name}'</i> para {group_notification_count} unidades"
        },
        "reminder": {
          "due": "<i>'{notifiable_name}'</i> não foi decidido para a unidade {level_name}."
        },
        "ticket_document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> em conversação <i>'{group_name}'</i>. | carregou documentos {group_notification_count} em conversa <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in conversation <i>'{group_name}'</i>."
        },
        "unit": {
          "visibled": "adicionou o cliente <i>'{customer_group_name}'</i> a <i>'{group_name}'</i> para a unidade <i>'{notifiable_name}'</i>."
        }
      },
      "title": "Notificações"
    }
  }
}
